import { get } from "svelte/store";
export class MapillaryMapLayer {
    constructor(parent, apiKey) {
        this.visible = false;
        this.parent = parent;
        this.apiKey = apiKey;
        this.parent.getImageIdStore().subscribe(() => {
            if (typeof this.map === "undefined")
                return;
            this.setHighlightFilter();
        });
        this.parent.getImageIdHoverStore().subscribe(() => {
            if (typeof this.map === "undefined")
                return;
            this.setHighlightFilter();
        });
    }
    setHighlightFilter() {
        const imageId = get(this.parent.getImageIdStore());
        const imageIdHover = get(this.parent.getImageIdHoverStore());
        if (typeof imageId !== "undefined" && typeof imageIdHover !== "undefined") {
            this.map.setFilter("mapillary-images-highlight", ["any", ["==", "id", Number(imageId)], ["==", "id", Number(imageIdHover)]]);
        }
        else if (typeof imageId !== "undefined") {
            this.map.setFilter("mapillary-images-highlight", ["==", "id", Number(imageId)]);
        }
        else if (typeof imageIdHover !== "undefined") {
            this.map.setFilter("mapillary-images-highlight", ["==", "id", Number(imageIdHover)]);
        }
        else {
            this.map.setFilter("mapillary-images-highlight", ["==", "id", ""]);
        }
    }
    onVisibleChanged(visible) {
        this.visible = visible;
        if (typeof this.map === "undefined")
            return;
        this.map.setLayoutProperty("mapillary-sequences", "visibility", visible ? "visible" : "none");
        this.map.setLayoutProperty("mapillary-sequences-highlight", "visibility", visible ? "visible" : "none");
        this.map.setLayoutProperty("mapillary-images", "visibility", visible ? "visible" : "none");
        this.map.setLayoutProperty("mapillary-images-highlight", "visibility", visible ? "visible" : "none");
    }
    addToMap(map) {
        this.map = map;
        // if no, add the layer.
        map.addSource("mapillary", {
            "type": "vector",
            "tiles": [
                `https://tiles.mapillary.com/maps/vtp/mly1_public/2/{z}/{x}/{y}?access_token=${this.apiKey}`
            ],
            "minzoom": 6,
            "maxzoom": 14
        });
        map.addLayer({
            "id": "mapillary-sequences",
            "type": "line",
            "source": "mapillary",
            "source-layer": "sequence",
            "layout": {
                "line-cap": "round",
                "line-join": "round",
                visibility: this.visible ? "visible" : "none"
            },
            "paint": {
                "line-opacity": 0.6,
                "line-color": "rgb(53, 175, 109)",
                "line-width": 2
            }
        }, "label");
        map.addLayer({
            "id": "mapillary-sequences-highlight",
            "type": "line",
            "source": "mapillary",
            "source-layer": "sequence",
            "layout": {
                "line-cap": "round",
                "line-join": "round",
                visibility: this.visible ? "visible" : "none"
            },
            "paint": {
                "line-opacity": 1,
                "line-color": "rgb(53, 175, 109)",
                "line-width": 4
            },
            filter: ["==", "id", ""]
        }, "label");
        map.addLayer({
            "id": "mapillary-images",
            "type": "circle",
            "minzoom": 17,
            "source": "mapillary",
            "source-layer": "image",
            "layout": {
                visibility: this.visible ? "visible" : "none"
            },
            "paint": {
                "circle-color": "#11b4da",
                "circle-radius": 4,
                "circle-stroke-width": 1,
                "circle-stroke-color": "#fff"
            }
        }, "label");
        map.addLayer({
            "id": "mapillary-images-highlight",
            "type": "circle",
            "minzoom": 17,
            "source": "mapillary",
            "source-layer": "image",
            "layout": {
                visibility: this.visible ? "visible" : "none"
            },
            "paint": {
                "circle-color": "#11b4da",
                "circle-radius": 8,
                "circle-stroke-width": 2,
                "circle-stroke-color": "#fff"
            },
            filter: ["==", "id", ""]
        }, "label");
        // map.on("mousemove", (e) => {
        //     const features = map.queryRenderedFeatures(e.point);
        //     const mapillaryFeatures = features.filter(x => x.layer.id === "mapillary-images");
        //     if (mapillaryFeatures.length > 0){
        //         this.parent.onMouseOverImage(mapillaryFeatures[0]);
        //         // const mapillaryImage = mapillaryFeatures[0];
        //         // sequenceId = mapillaryImage.properties["sequence_id"] as string;
        //         // imageId = mapillaryImage.properties["id"] as number;
        //         // this.parent.getImageIdStore().set(`${imageId}`);
        //     } else {
        //         //this.parent.getImageIdStore().set(undefined);
        //     }
        //     //map.setFilter("mapillary-sequences-highlight", ["==", "id", sequenceId]);
        // });
        // map.on("click", (e) => {
        //     const features = map.queryRenderedFeatures(e.point);
        //     const mapillaryFeatures = features.filter(x => x.layer.id === "mapillary-images");
        //     if (mapillaryFeatures.length > 0){
        //         this.parent.onMouseClickImage(mapillaryFeatures[0]);
        //         // const mapillaryImage = mapillaryFeatures[0];
        //         // sequenceId = mapillaryImage.properties["sequence_id"] as string;
        //         // imageId = mapillaryImage.properties["id"] as number;
        //         // this.parent.getImageIdStore().set(`${imageId}`);
        //     } else {
        //         //this.parent.getImageIdStore().set(undefined);
        //     }
        //     //map.setFilter("mapillary-sequences-highlight", ["==", "id", sequenceId]);
        // });
    }
    onMapClick(e) {
        if (!this.visible)
            return false;
        // layer is visible, check for an image.
        const features = this.map.queryRenderedFeatures(e.point, {
            layers: ["mapillary-images"]
        });
        if (features.length === 0)
            return false;
        // report clicked image to parent.
        this.parent.onMouseClickImage(features[0]);
        return true;
    }
    onMapMouseOver(e) {
        if (!this.visible)
            return false;
        // layer is visible, check for an image.
        const features = this.map.queryRenderedFeatures(e.point, {
            layers: ["mapillary-images"]
        });
        if (features.length === 0) {
            this.parent.onMouseOverImage(undefined);
            return false;
        }
        // report clicked image to parent.
        this.parent.onMouseOverImage(features[0]);
        return true;
    }
}
